var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSystem = function SvgSystem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.833H9.167L5 18.333v-2.5H2.5V2.5h15zm-5.833-6.666V10H5.833v1.667h5.834v.833h1.666v-.833h.834V10h-.834v-.833zM5.833 7.5H10V5.833H5.833z"
  })));
};
export default SvgSystem;